import React from 'react';
import './Careers.css';

const Careers = () => {
  return (
    <div className="careers-page">
      <header className="careers-header">
        <h1>Careers</h1>
        <p>We believe in the power of play to drive deeper customer engagement. Our people make it possible.</p>
      </header>

      <section className="openings-section">
        <h2>Current Openings</h2>
        <div className="search-bar">
          <input type="text" placeholder="Enter Role" disabled />
          <button disabled>Search</button>
        </div>

        <div className="no-openings">
          <p>No open positions at the moment.</p>
        </div>
      </section>
    </div>
  );
};

export default Careers;
